//
const equal = { label: 'Is exactly', value: '=', icon: 'equal' };
const notEqual = { label: 'Not equal', value: '<>', icon: 'not-equal' };
const contains = { label: 'Contains', value: 'contains', icon: 'tilde' };
const startWith = { label: 'starts with', value: 'starts with', icon: 'arrow-expand-right' };

const textFieldMenu = [
    contains,
    equal,
    { label: 'Is empty', value: 'is null', icon: 'circle-off-outline' },
    { label: 'Does NOT contain', value: 'not contains', icon: 'not-equal' },
];

const typeaheadMenu = [
    { label: 'Is set to ANY', value: 'in', icon: 'tilde' },
    { label: 'Is set to ALL', value: 'all', icon: 'equal' },
    { label: 'Does NOT contain', value: 'not in', icon: 'not-equal-variant' },
];
// created typeahead map in OperatorSelect.js because of circular dependency issue if we import it here 
// To add a new typeahead with operators, update both:
// 1. TYPEAHEAD_OPTIONS below
// 2. TYPEAHEAD_COMPONENT_MAP in OperatorSelect.js
export const TYPEAHEAD_OPTIONS = ['userTypeahead', 'teamTypeahead', 'workspaceTypeahead'];

const buildTypeaheadOperators = () => {
    const entries = TYPEAHEAD_OPTIONS.map(key => [key, typeaheadMenu]);
    return Object.fromEntries(entries);
};

export const operatorsMenu = {
    text: textFieldMenu,
    number: [equal, notEqual],
    uuid: [equal, startWith],
    ...buildTypeaheadOperators(),
};

export const isTypeaheadOption = type => TYPEAHEAD_OPTIONS.includes(type);
